import React, { useState } from "react";
import DateInput from "../../../../parts/inputs/date-input";
import moment from "moment";
import MonthSelector from "../../../athlete-portal/calendar/progress-photos/components/MonthSelector";
import MonthController from "../../../../parts/MonthController";
import WeekSelectionBar from "../../../athlete-portal/calendar/body-composition/components/WeekSelectionBar";
import { DateRangeController } from "../../../athlete-portal/profile/periodization/parts/Header";

const Dates = () => {
  //Month Selector
  const [monthlyDate, setMonthtlyDate] = useState(moment());
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, "week"));
  const [dateTo, setDateTo] = useState(moment().add(1, "week"));

  return (
    <>
      <div className="max-w-60">
        <h4 className="mb-4">Date Inputs</h4>
        <div role="calendar-date-selectors">
          <DateInput /> <span>to</span> <DateInput />
        </div>
        <h4 className="mt-6 mb-4">Month List selectors</h4>
        <MonthSelector date={monthlyDate} setDate={setMonthtlyDate} />
      </div>
      <h4 className="mt-6 mb-4">Month Controller</h4>
      <MonthController date={monthlyDate} setDate={setMonthtlyDate} />

      <h4>Date Range Controller</h4>
      <p className="p2">
        Keep Range: Keeps the range between initial and final date
      </p>
      <DateRangeController
        dateFromState={dateFrom}
        setDateFromState={setDateFrom}
        dateToState={dateTo}
        setDateToState={setDateTo}
        keepRange={true}
      />
      <p className="p2 mt-4">
        Doesnt Keep Range: Updates one extreme at the time
      </p>
      <DateRangeController
        dateFromState={dateFrom}
        setDateFromState={setDateFrom}
        dateToState={dateTo}
        setDateToState={setDateTo}
      />
    </>
  );
};

export default Dates;
